import React from 'react';
import { GamesBreadcrumb } from './index';
import { PlayGameLink } from './index';

export default function TerritoryPage() {
  return (
    <div className="mx-auto rounded-xl bg-white p-4 shadow dark:bg-slate-900/80">
      <GamesBreadcrumb game="Territory" />
      <h1 className="mb-4 text-3xl font-bold text-slate-900 dark:text-slate-100">Territory</h1>
      <img
        src="/thumbnails/Territory.png"
        alt="Territory game screenshot"
        className="mx-auto mb-4 w-full max-w-md rounded-lg bg-white shadow dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">About Territory</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Territory is a single-player logic puzzle where you place one marker in each row, column, and region without letting any markers touch. Every puzzle has a unique solution, so careful deduction beats guesswork.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc space-y-1 pl-6 text-gray-700 dark:text-gray-300">
          <li>Use the grid to place markers so every row, column, and territory contains exactly one.</li>
          <li>Keep markers separated horizontally, vertically, and diagonally.</li>
          <li>Use the hint system to spot forced moves and narrow down the remaining possibilities.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Why it’s fun</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Territory feels calm at first but quickly turns into a satisfying deduction challenge. It is perfect for short solo sessions or for winding down with a puzzle that demands focus.
        </p>
      </section>
      <section>
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Play Territory</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Jump in and test your logic with a fresh puzzle. The game is free to play right here with no download required.
        </p>
        <PlayGameLink game="Territory" gameTitle="Territory" />
      </section>
    </div>
  );
}
